import React, { useState } from 'react';
import type { User } from '../../types';

interface LoginFormProps {
    onLogin: (user: User) => void;
    onCancel?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin, onCancel }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        rememberMe: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Username: formData.username,
                    Password: formData.password,
                    RememberMe: formData.rememberMe
                }),
            });

            const result = await response.json();

            if (response.ok && result.data) {
                // Save user data to localStorage
                localStorage.setItem('user', JSON.stringify(result.data.user));
                onLogin(result.data.user);
            } else {
                setError(result.error || 'Ошибка входа');
            }
        } catch (err) {
            setError('Произошла ошибка при входе');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    return (
        <div className="login-form row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <div className="card shadow">
                    <div className="card-header bg-primary text-white text-center">
                        <h2 className="mb-0">Lira MarketPlace</h2>
                        <h4 className="mb-0">Вход в систему</h4>
                    </div>
                    <div className="card-body">
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-2">
                                <label htmlFor="username" className="form-label">
                                    Имя пользователя
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleInputChange}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="mb-2">
                                <label htmlFor="password" className="form-label">
                                    Пароль
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="mb-2 d-grid gap-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="rememberMe"
                                    name="rememberMe"
                                    checked={formData.rememberMe}
                                    onChange={handleInputChange}
                                    disabled={loading}
                                />
                                <label className="form-check-label" htmlFor="rememberMe">
                                    Запомнить меня
                                </label>
                                <button
                                    type="submit"
                                    className="btn btn-primary ml-2"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            Вход...
                                        </>
                                    ) : (
                                        'Войти'
                                    )}
                                </button>

                                {onCancel && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={onCancel}
                                        disabled={loading}
                                    >
                                        Отмена
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                    <div className="card-footer text-center text-muted">
                        <small></small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
